import type { BedHistoryAlertDto } from '@/shared/api/modules/floor-plan';
import { Icon } from '@/shared/assets/icons';
import { cn } from '@/shared/lib/cn';
import { Typography } from '@/shared/ui';
import { Tooltip } from 'antd';
import type { FC } from 'react';

type BedHistoryAlertsProps = {
  alerts: BedHistoryAlertDto[];
};

/**
 * One icon per history record (card #200). The tooltip lists every message on the record, errors
 * first. The icon is gray when the only flags are informational (e.g. several beds in one room).
 */
export const BedHistoryAlerts: FC<BedHistoryAlertsProps> = ({ alerts }) => {
  if (!alerts.length) return null;

  const hasWarning = alerts.some((alert) => alert.severity === 'warning');

  return (
    <Tooltip
      color="white"
      title={
        <ul className="m-0 flex list-none flex-col gap-1 p-1">
          {alerts.map((alert) => (
            <li key={alert.code}>
              <Typography className="text-gray-700">{alert.message}</Typography>
            </li>
          ))}
        </ul>
      }
    >
      <span
        className="inline-flex"
        data-testid="bed-history-alert"
        data-severity={hasWarning ? 'warning' : 'info'}
      >
        <Icon
          name="warning-triangle"
          size={16}
          className={cn(
            'hover:cursor-pointer',
            hasWarning ? 'text-amber-600' : 'text-gray-400'
          )}
        />
      </span>
    </Tooltip>
  );
};
